import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiBaseService } from "./api-base.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { UserService } from "src/app/shared/services/user.service";
import { MomentFormatterService } from "src/app/shared/helpers/datetime/moment-formatter.service";
import * as moment from "moment";
import { TimeConverter } from "src/app/shared/services/time-converter.service";

@Injectable({
  providedIn: 'root'
})
export class AmlTimeService extends ApiBaseService {
  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService, private momentFormatter: MomentFormatterService, private timeConverter: TimeConverter) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-time-key', }) };
    this.baseUrl = `${this.configService.config.timeUrl}/api/amltimes`;
  }

  create(date: Date, employeeId: number, timeTypeId: number, startTime: string, stopTime: string): Observable<any> {
    const request = {
      "Date": this.momentFormatter.dateOnly(moment(date)),
      "EmployeeId": employeeId,
      "TimeTypeId": timeTypeId,
      "StartTime": this.timeConverter.getTimeInputConvertedToHoursAndMinutes(startTime),
      "StopTime": this.timeConverter.getTimeInputConvertedToHoursAndMinutes(stopTime)
    };
    
    return this.http.post<any>(`${this.baseUrl}/post`, request, this.httpOptions);
  }

  update(id: number, date: Date, employeeId: number, timeTypeId: number, startTime: string, stopTime: string): Observable<any> {
    const request = {
      "TimeId": id,
      "Date": this.momentFormatter.dateOnly(moment(date)),
      "EmployeeId": employeeId,
      "TimeTypeId": timeTypeId,
      "StartTime": this.timeConverter.getTimeInputConvertedToHoursAndMinutes(startTime),
      "StopTime": this.timeConverter.getTimeInputConvertedToHoursAndMinutes(stopTime)
    };

    return this.http.patch<any>(`${this.baseUrl}/update`, request, this.httpOptions);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/delete?id=${id}`, this.httpOptions);
  }
}
